import { apiClient } from '../../services/api';

const state = () => ({
  configsMosaico: [],
  configSelecionada: null,
  orientacaoSelecionada: null,
  qtd_de_cards_por_linha: 1,
  exibirUf: null,
});

const getters = {
  getConfigsMosaico: state => {
    return state.configsMosaico;
  },
  getConfigSelecionada: state => {
    return state.configSelecionada;
  },
  getOrientacaoSelecionada: state => {
    return state.orientacaoSelecionada;
  },
  getQuantidadeDeCardsPorLinha: state => {
    return state.qtd_de_cards_por_linha
  },
  getFlagExibirUfMosaico: state => {
    return state.exibirUf;
  }
};

const actions = {
  async getAllConfigsMosaico({ commit }, payload) {
    const { cod_producao } = payload;
    return apiClient.get(`/producao/${cod_producao}/mosaicoConfig/`)
      .then((response) => {
        commit('setConfigsMosaico', response.data);
      });
  },
  async getPreferenciasMosaico({ commit }, payload) {
    const { cod_producao } = payload;
    return apiClient.get(
      `producao/${cod_producao}/preferenciasMosaico`
    ).then((response) => {
      const orientacaoSelecionada = response.data.orientacaoSelecionada ? response.data.orientacaoSelecionada : 'G';
      commit('setConfigMosaicoSelecionada', response.data.configMosaico);
      commit('setOrientacaoSelecionada', orientacaoSelecionada);
      commit('setQuantidadeDeCardsPorLinha', response.data.qtd_de_cards_por_linha);
      commit('setFlagExibirUfMosaico', response.data.flg_exibir_uf ?? true)
    });
  },
  async updatePreferenciasMosaico({ commit }, payload) {
    const { codProducao, configSelecionada, orientacaoSelecionada, qtd_de_cards_por_linha, exibir_uf } = payload;

    return apiClient.patch(`producao/${codProducao}/preferenciasMosaico`, {
      configSelecionada: configSelecionada.idConfigMosaico,
      orientacaoSelecionada,
      qtd_de_cards_por_linha,
      exibir_uf
    }).then(() => {
      commit('setConfigMosaicoSelecionada', configSelecionada);
      commit('setOrientacaoSelecionada', orientacaoSelecionada);
      commit('setQuantidadeDeCardsPorLinha', qtd_de_cards_por_linha);
      commit('setFlagExibirUfMosaico', exibir_uf)
    })
  }
}

const mutations = {
  setConfigsMosaico(state, payload) {
    state.configsMosaico = payload;
  },
  setConfigMosaicoSelecionada(state, payload) {
    state.configSelecionada = payload;
    localStorage.setItem('@socialcam/config_mosaico', JSON.stringify(payload));
  },
  setOrientacaoSelecionada(state, payload) {
    state.orientacaoSelecionada = payload;
    localStorage.setItem('@socialcam/tipo_mosaico', payload);
  },
  setQuantidadeDeCardsPorLinha(state, payload) {
    state.qtd_de_cards_por_linha = payload;
    localStorage.setItem('@socialcam/qtd_de_cards_por_linha', payload)
  },
  setFlagExibirUfMosaico(state, payload) {
    state.exibirUf = payload;
    localStorage.setItem("@socialcam/exibir_uf_mosaico", payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
